import Vue from 'vue'
import Vuex from 'vuex'

import User from '@/store/module/User'

const store = new Vuex.Store({
  namespaced: true,
  modules: {
    User
  }
});
export default store